import { render, staticRenderFns } from "./DFashionView.vue?vue&type=template&id=400d4698"
import script from "./DFashionView.vue?vue&type=script&lang=js"
export * from "./DFashionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports